export default __webpack_public_path__ + "static/media/CV.2ea4d0e6.webp";